import {useEffect, useRef} from 'react';

import {getUserData} from 'utils/functions/getUserData/getUserData';

export interface AuthIframeProps {
  src: string;
  title: string;
}

function AuthedIframe({src, title}: AuthIframeProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  async function handleMessage(event: MessageEvent) {
    if (event.origin === src && event.data.type === 'READY') {
      const {user} = getUserData();
      sendMessageToIframe({
        id: user.id,
        email: user.email,
        username: user.username,
      });
    }
  }

  function sendMessageToIframe(message: Record<string, unknown>) {
    iframeRef.current?.contentWindow?.postMessage(
      {type: process.env.REACT_APP_IFRAME_KEY, ...message},
      src,
    );
  }

  useEffect(() => {
    if (iframeRef.current) {
      window.addEventListener('message', handleMessage);
    }
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [iframeRef.current]);

  return (
    <iframe
      src={src}
      title={title}
      ref={iframeRef}
      style={{width: '100%', height: 'calc(100vh - 3.9rem)', border: 'none'}}
    />
  );
}

export default AuthedIframe;
